// src/views/condominos/CondominoModal.jsx
import React, { useState, useEffect, useRef } from "react";
import condominosService from "../../services/condominosService";
import { estadosBR } from "../../data/condominiosData";
import ConfirmModal from "../../components/ui/ConfirmModal";

const fmtCPF  = v => { const d=v.replace(/\D/g,"").slice(0,11); return d.replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d{1,2})$/,"$1-$2"); };
const fmtCNPJ = v => { const d=v.replace(/\D/g,"").slice(0,14); return d.replace(/^(\d{2})(\d)/,"$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3").replace(/\.(\d{3})(\d)/,".$1/$2").replace(/(\d{4})(\d)/,"$1-$2"); };
const fmtPhone= v => { const d=v.replace(/\D/g,"").slice(0,11); return d.length<=10?d.replace(/^(\d{2})(\d{4})(\d{0,4})/,"($1) $2-$3").trim():d.replace(/^(\d{2})(\d{5})(\d{0,4})/,"($1) $2-$3").trim(); };
const fmtCEP  = v => { const d=v.replace(/\D/g,"").slice(0,8); return d.replace(/^(\d{5})(\d)/,"$1-$2"); };
const sanDate = v => { if(!v) return ""; if(typeof v==="string"&&v.includes("T")) return v.split("T")[0]; return v; };

function validarCPF(v) {
  const d = v.replace(/\D/g,"");
  if (d.length!==11 || /^(\d)\1+$/.test(d)) return false;
  let s=0; for(let i=0;i<9;i++) s+=parseInt(d[i],10)*(10-i);
  let r=(s*10)%11; if(r===10||r===11) r=0; if(r!==parseInt(d[9],10)) return false;
  s=0; for(let i=0;i<10;i++) s+=parseInt(d[i],10)*(11-i);
  r=(s*10)%11; if(r===10||r===11) r=0; return r===parseInt(d[10],10);
}
function validarCNPJ(v) {
  const d = v.replace(/\D/g,"");
  if (d.length!==14 || /^(\d)\1+$/.test(d)) return false;
  const calc=(n)=>{let s=0,p=n-7;for(let i=0;i<n;i++){s+=parseInt(d[i],10)*p;p=p===2?9:p-1;}const r=s%11;return r<2?0:11-r;};
  return calc(12)===parseInt(d[12],10) && calc(13)===parseInt(d[13],10);
}
const emailValido = v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

const EMPTY = {
  nmCompleto:"", dtCadastro:new Date().toISOString().split("T")[0],
  email:"", telefone:"", celular:"", nrWhatsApp:"", contato:"", observacao:"",
  tpPessoa:"Fisica", cpf_cnpj:"", rg:"", inscEstadual:"",
  dtNascimento:"", sexo:"Masculino", estCivil:"Solteiro", nacionalidade:"Brasileira",
  profissao:"", localTrabalho:"", telComercial:"",
  nmConjuge:"", profConjuge:"", cpfConjuge:"", rgConjuge:"", dtNascConjuge:"",
  inativo:false,
  cep:"", logradouro:"", numero:"", complemento:"", bairro:"", cidade:"", uf:"SP",
  // Avatar (1)
  avatar:"",
  // Bancário/PIX (3)
  pixTipo:"", pixChave:"", bancoNome:"", bancoAgencia:"", bancoConta:"", bancoTpConta:"Corrente",
  // Tags (5)
  tags:"",
  // Aniversário (6)
  aniversarioOptIn:1,
  // LGPD (11)
  lgpdAceite:0, lgpdAceiteEm:"", lgpdVersao:"",
};

const ESTADOS_CIVIS = ["Solteiro","Casado","Divorciado","Viuvo","UniaoEstavel"];
const LABELS_EC = { Solteiro:"Solteiro(a)", Casado:"Casado(a)", Divorciado:"Divorciado(a)", Viuvo:"Viúvo(a)", UniaoEstavel:"União Estável" };

const TIPOS_DOC = [
  "RG", "CPF", "CNH", "Passaporte", "ContratoLocacao", "ProcuracaoSindico",
  "ComprovanteResidencia", "EscrituraImovel", "MatriculaImovel", "Outros"
];

// ── Componente: Acesso ao Portal ─────────────────────────────────────────
// Toda gestão do usuário-condômino acontece aqui (criar, resetar, revogar, etc.).
// Eliminou a necessidade do operador ir em "Usuários".
function PortalAcessoCondomino({ idCondomino, emailCondomino, inativo }) {
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);
  const [erro, setErro] = useState(null);
  const [confirma, setConfirma] = useState(null);
  // Quando a senha temporária é gerada, exibimos pra o operador copiar
  const [senhaInfo, setSenhaInfo] = useState(null);
  // Email persistido (lido do banco). Permite detectar se o form tem
  // alterações pendentes (operador editou o email mas não salvou).
  const [emailPersistido, setEmailPersistido] = useState(null);
  // Estado do botão "Reenviar e-mail" (não troca a senha; reaproveita a atual em sessão).
  const [reenviando, setReenviando] = useState(false);
  const [reenvioStatus, setReenvioStatus] = useState(null);

  const carregar = async () => {
    if (!idCondomino) return;
    setLoading(true); setErro(null);
    try {
      const [stRes, condRes] = await Promise.all([
        condominosService.portalAcessoStatus(idCondomino),
        condominosService.buscarPorId(idCondomino),
      ]);
      setStatus(stRes?.data || null);
      setEmailPersistido((condRes?.data?.email || "").trim().toLowerCase() || null);
    } catch (e) { setErro(e?.message || "Falha ao carregar status do portal."); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); /* eslint-disable-line */ }, [idCondomino]);

  // Detecta se o operador alterou o email no form e ainda NÃO salvou
  const emailForm = (emailCondomino || "").trim().toLowerCase();
  const emailPendente = emailForm !== (emailPersistido || "");

  const acao = async (fn) => {
    setBusy(true); setErro(null); setSenhaInfo(null);
    try {
      const r = await fn();
      if (r?.data?.senhaTemporaria) {
        setSenhaInfo({
          email: r.data.email,
          senha: r.data.senhaTemporaria,
          emailEnviado: !!r.data.emailEnviado,
          emailErro: r.data.emailErro || null,
        });
      }
      await carregar();
    } catch (e) { setErro(e?.message || "Falha na operação."); }
    finally { setBusy(false); setConfirma(null); }
  };

  const copiarSenha = () => {
    if (!senhaInfo?.senha) return;
    navigator.clipboard?.writeText(senhaInfo.senha).catch(()=>{});
  };

  const reenviarEmail = async () => {
    if (!senhaInfo?.senha) return;
    setReenviando(true); setReenvioStatus(null);
    try {
      const r = await condominosService.reenviarEmailPortal(idCondomino, senhaInfo.senha);
      setReenvioStatus({ ok:true, msg: r?.message || "E-mail reenviado com sucesso." });
      setSenhaInfo(p => p ? { ...p, emailEnviado: true } : p);
    } catch (e) {
      setReenvioStatus({ ok:false, msg: e?.message || "Falha no reenvio." });
    } finally {
      setReenviando(false);
    }
  };

  if (loading) {
    return <div className="text-center p-4"><i className="bi bi-hourglass-split me-2"/>Carregando…</div>;
  }

  return (
    <div className="form-section">
      <div className="form-section-title">
        <i className="bi bi-key"/> Acesso ao Portal do Condômino
      </div>

      {erro && (
        <div className="alert alert-danger d-flex align-items-start gap-2 py-2" style={{fontSize:13}}>
          <i className="bi bi-exclamation-triangle"/><div>{erro}</div>
        </div>
      )}

      {senhaInfo && (
        <div className={`alert d-flex align-items-start gap-2 py-2 ${senhaInfo.emailEnviado ? "alert-success" : "alert-warning"}`} style={{fontSize:13}}>
          <i className={`bi ${senhaInfo.emailEnviado ? "bi-envelope-check" : "bi-shield-check"}`}/>
          <div className="flex-grow-1">
            {senhaInfo.emailEnviado ? (
              <>
                <strong>E-mail enviado para o condômino</strong> com as credenciais de acesso.<br/>
                <span style={{fontSize:12,color:"var(--gray-600)"}}>Destinatário:</span> <code>{senhaInfo.email}</code>
                <div style={{fontSize:11,color:"var(--gray-600)",marginTop:6}}>
                  Caso o condômino não receba, verifique a caixa de spam ou{" "}
                  <button type="button" className="btn btn-link btn-sm p-0 align-baseline"
                    style={{fontSize:11,verticalAlign:"baseline"}}
                    disabled={reenviando}
                    onClick={reenviarEmail}>
                    {reenviando ? "reenviando…" : "clique aqui para reenviar"}
                  </button>.
                  <div style={{marginTop:4}}>
                    Senha temporária (para repasse manual): <code style={{fontWeight:700}}>{senhaInfo.senha}</code>
                    <button type="button" className="btn btn-sm btn-outline-secondary ms-2" onClick={copiarSenha}>
                      <i className="bi bi-clipboard me-1"/>Copiar
                    </button>
                  </div>
                  {reenvioStatus && (
                    <div style={{marginTop:4,color: reenvioStatus.ok ? "#166534" : "#B45309"}}>
                      <i className={`bi ${reenvioStatus.ok ? "bi-check-circle" : "bi-exclamation-triangle"} me-1`}/>
                      {reenvioStatus.msg}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <strong>Senha gerada</strong> — não foi possível enviar o e-mail automaticamente.<br/>
                <span style={{fontSize:12,color:"var(--gray-600)"}}>E-mail de login:</span> <code>{senhaInfo.email}</code><br/>
                <span style={{fontSize:12,color:"var(--gray-600)"}}>Senha temporária:</span>{" "}
                <code style={{fontSize:14,fontWeight:700,letterSpacing:1}}>{senhaInfo.senha}</code>
                <button type="button" className="btn btn-sm btn-outline-warning ms-2" onClick={copiarSenha}>
                  <i className="bi bi-clipboard me-1"/>Copiar
                </button>
                <button type="button" className="btn btn-sm btn-warning ms-2"
                  disabled={reenviando}
                  onClick={reenviarEmail}>
                  <i className="bi bi-arrow-repeat me-1"/>
                  {reenviando ? "Reenviando…" : "Tentar enviar e-mail novamente"}
                </button>
                {senhaInfo.emailErro && (
                  <div style={{fontSize:11,color:"var(--gray-600)",marginTop:6}}>
                    <i className="bi bi-info-circle me-1"/>Motivo: {senhaInfo.emailErro}
                  </div>
                )}
                {reenvioStatus && (
                  <div style={{fontSize:12,marginTop:6,color: reenvioStatus.ok ? "#166534" : "#B45309"}}>
                    <i className={`bi ${reenvioStatus.ok ? "bi-check-circle" : "bi-exclamation-triangle"} me-1`}/>
                    {reenvioStatus.msg}
                  </div>
                )}
                <div style={{fontSize:11,color:"var(--gray-500)",marginTop:4}}>
                  Repasse a senha ao condômino com segurança. Ele será obrigado a trocar a senha no primeiro acesso.
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Status: sem acesso ainda */}
      {!status?.existe && (
        <div>
          <p style={{fontSize:13,color:"var(--gray-600)",margin:"6px 0 14px"}}>
            Este condômino ainda <strong>não tem acesso ao portal</strong>.
            Para conceder, o e-mail do condômino precisa estar preenchido.
          </p>
          <div className="d-flex align-items-center gap-2 mb-3" style={{fontSize:13}}>
            <i className="bi bi-envelope"/>
            <span><strong>E-mail de login:</strong> {emailCondomino || <span style={{color:"#B91C1C"}}>não cadastrado</span>}</span>
          </div>
          {emailPendente && emailCondomino && (
            <div className="alert alert-warning d-flex align-items-start gap-2 py-2" style={{fontSize:12}}>
              <i className="bi bi-exclamation-triangle mt-1"/>
              <div className="flex-grow-1">
                Você alterou o e-mail nesta tela mas <strong>ainda não salvou</strong> o cadastro.<br/>
                Clique em <strong>Salvar</strong> (rodapé) para gravar o e-mail e, em seguida, volte aqui para conceder o acesso.
                <div style={{marginTop:6}}>
                  <button type="button" className="btn btn-sm btn-outline-secondary" onClick={carregar} disabled={loading}>
                    <i className="bi bi-arrow-clockwise me-1"/>
                    Já salvei, atualizar
                  </button>
                </div>
              </div>
            </div>
          )}
          {inativo && (
            <div className="alert alert-warning d-flex align-items-center gap-2 py-2" style={{fontSize:12}}>
              <i className="bi bi-exclamation-triangle"/>
              Condômino marcado como <strong>Inativo</strong>: o acesso ao portal está bloqueado.
            </div>
          )}
          <button
            type="button"
            className="btn btn-primary"
            disabled={busy || !emailCondomino || inativo || emailPendente}
            title={emailPendente ? "Salve o cadastro do condômino antes de conceder o acesso." : undefined}
            onClick={() => acao(() => condominosService.criarPortalAcesso(idCondomino))}
          >
            <i className="bi bi-key me-1"/>
            {busy ? "Concedendo…" : "Conceder acesso ao portal"}
          </button>
        </div>
      )}

      {/* Status: já tem acesso */}
      {status?.existe && (
        <div>
          <div className="row g-3 mb-3" style={{fontSize:13}}>
            <div className="col-md-6">
              <div><strong><i className="bi bi-envelope me-1"/>E-mail de login:</strong></div>
              <code style={{fontSize:13}}>{status.email}</code>
            </div>
            <div className="col-md-6">
              <div><strong><i className="bi bi-toggles me-1"/>Status:</strong></div>
              {status.ativo ? (
                <span className="badge text-bg-success"><i className="bi bi-check-circle me-1"/>Ativo</span>
              ) : (
                <span className="badge text-bg-danger"><i className="bi bi-slash-circle me-1"/>Revogado</span>
              )}
              {status.primeiroAcesso ? (
                <span className="badge text-bg-warning ms-2"><i className="bi bi-key me-1"/>Aguardando troca de senha</span>
              ) : null}
            </div>
            {status.dtUltimoAcesso && (
              <div className="col-12" style={{fontSize:12,color:"var(--gray-600)"}}>
                <i className="bi bi-clock-history me-1"/>
                Último acesso: {new Date(status.dtUltimoAcesso).toLocaleString("pt-BR")}
              </div>
            )}
          </div>

          <div className="d-flex flex-wrap gap-2">
            <button type="button" className="btn btn-outline-primary btn-sm"
              disabled={busy || !status.ativo}
              onClick={() => setConfirma({
                titulo: "Resetar senha do portal",
                texto: "Uma nova senha temporária será gerada e as sessões ativas serão encerradas. O condômino precisará trocar a senha no próximo login. Continuar?",
                acao: () => acao(() => condominosService.resetarSenhaPortal(idCondomino)),
              })}>
              <i className="bi bi-arrow-clockwise me-1"/>Resetar senha
            </button>

            {status.ativo ? (
              <button type="button" className="btn btn-outline-warning btn-sm"
                disabled={busy}
                onClick={() => setConfirma({
                  titulo: "Revogar acesso ao portal",
                  texto: "O condômino perderá o acesso ao portal e todas as sessões ativas serão encerradas. O usuário ficará desativado, mas o histórico é preservado.",
                  perigo: true,
                  acao: () => acao(() => condominosService.revogarPortalAcesso(idCondomino)),
                })}>
                <i className="bi bi-slash-circle me-1"/>Revogar acesso
              </button>
            ) : (
              <button type="button" className="btn btn-outline-success btn-sm"
                disabled={busy}
                onClick={() => acao(() => condominosService.reativarPortalAcesso(idCondomino))}>
                <i className="bi bi-check-circle me-1"/>Reativar acesso
              </button>
            )}

            <button type="button" className="btn btn-outline-danger btn-sm"
              disabled={busy}
              onClick={() => setConfirma({
                titulo: "Excluir acesso ao portal",
                texto: "O usuário será removido definitivamente. Esta ação não pode ser desfeita. Para apenas suspender o acesso, prefira 'Revogar'. Continuar?",
                perigo: true,
                acao: () => acao(() => condominosService.excluirPortalAcesso(idCondomino)),
              })}>
              <i className="bi bi-trash me-1"/>Excluir acesso
            </button>
          </div>
        </div>
      )}

      {confirma && (
        <ConfirmModal
          titulo={confirma.titulo}
          mensagem={confirma.texto}
          textoOk={confirma.perigo ? "Confirmar" : "Sim"}
          perigo={!!confirma.perigo}
          carregando={busy}
          onCancel={() => setConfirma(null)}
          onConfirm={() => confirma.acao?.()}
        />
      )}
    </div>
  );
}

function DocumentosCondomino({ idCondomino }) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const [novoTipo, setNovoTipo] = useState("RG");
  const [novoDescricao, setNovoDescricao] = useState("");
  const [arquivo, setArquivo] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const carregar = async () => {
    if (!idCondomino) return;
    setLoading(true); setErro(null);
    try { const r = await condominosService.listarDocumentos(idCondomino); setDocs(r.data||[]); }
    catch(e){ setErro(e.message); }
    setLoading(false);
  };
  useEffect(() => { carregar(); /* eslint-disable-next-line */ }, [idCondomino]);

  const enviar = async () => {
    if (!arquivo) return setErro("Selecione um arquivo.");
    if (arquivo.size > 5*1024*1024) return setErro("Arquivo excede 5MB.");
    setEnviando(true); setErro(null);
    try {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        try {
          await condominosService.uploadDocumento(idCondomino, {
            tipo: novoTipo, nomeArquivo: arquivo.name, mimeType: arquivo.type, tamanho: arquivo.size,
            descricao: novoDescricao || null, arquivo: ev.target.result,
          });
          setNovoDescricao(""); setArquivo(null);
          await carregar();
        } catch(e) { setErro(e.message); }
        setEnviando(false);
      };
      reader.readAsDataURL(arquivo);
    } catch(e) { setErro(e.message); setEnviando(false); }
  };

  const baixar = async (d) => {
    try {
      const r = await condominosService.baixarDocumento(idCondomino, d.id);
      const a = document.createElement("a");
      a.href = r.data.arquivo;
      a.download = r.data.nomeArquivo || "documento";
      document.body.appendChild(a); a.click(); a.remove();
    } catch(e) { setErro(e.message); }
  };

  const [confirmacaoDoc, setConfirmacaoDoc] = useState(null);
  const excluir = (d) => {
    setConfirmacaoDoc({
      titulo: "Excluir documento?",
      mensagem: `Deseja realmente excluir o documento "${d.nomeArquivo}"?`,
      textoOk: "Excluir",
      perigo: true,
      onConfirm: async () => {
        setConfirmacaoDoc(null);
        try { await condominosService.excluirDocumento(idCondomino, d.id); await carregar(); }
        catch(e) { setErro(e.message); }
      },
    });
  };

  if (!idCondomino) {
    return <div className="alert alert-info py-2" style={{fontSize:13}}>
      <i className="bi bi-info-circle me-2"/>Salve o condômino antes de anexar documentos.
    </div>;
  }

  return (
    <div className="form-section">
      <div className="form-section-title"><i className="bi bi-paperclip"/> Documentos do Condômino</div>
      {erro && <div className="alert alert-danger py-2" style={{fontSize:13}}><i className="bi bi-exclamation-triangle-fill me-2"/>{erro}</div>}

      <div style={{background:"var(--bg-surface-alt)",border:"1px solid var(--border-color)",borderRadius:8,padding:12,marginBottom:14}}>
        <div className="row g-2 align-items-end">
          <div className="col-md-3">
            <label className="form-label" style={{fontSize:12}}>Tipo</label>
            <select className="form-select form-select-sm" value={novoTipo} onChange={e=>setNovoTipo(e.target.value)}>
              {TIPOS_DOC.map(t=><option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label" style={{fontSize:12}}>Descrição (opcional)</label>
            <input className="form-control form-control-sm" value={novoDescricao} onChange={e=>setNovoDescricao(e.target.value)} placeholder="Ex: 2ª via, validade 2030"/>
          </div>
          <div className="col-md-3">
            <label className="form-label" style={{fontSize:12}}>Arquivo (até 5MB)</label>
            <input type="file" className="form-control form-control-sm" accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx" onChange={e=>setArquivo(e.target.files?.[0]||null)}/>
          </div>
          <div className="col-md-2">
            <button className="btn btn-success btn-sm w-100" onClick={enviar} disabled={enviando||!arquivo}>
              {enviando ? <span className="spinner-border spinner-border-sm"/> : <><i className="bi bi-upload"/> Enviar</>}
            </button>
          </div>
        </div>
      </div>

      {loading ? <div className="text-center py-3"><span className="spinner-border spinner-border-sm me-2"/>Carregando...</div>
        : docs.length === 0 ? <div className="text-center py-3 text-muted" style={{fontSize:13}}>Nenhum documento anexado.</div>
        : <table className="table table-custom table-sm">
            <thead><tr><th>Tipo</th><th>Arquivo</th><th>Descrição</th><th>Tamanho</th><th>Enviado em</th><th style={{width:80}}>Ações</th></tr></thead>
            <tbody>
              {docs.map(d=>(
                <tr key={d.id}>
                  <td><span className="badge text-bg-light border">{d.tipo}</span></td>
                  <td style={{fontSize:12.5}}><i className="bi bi-file-earmark me-1 text-primary"/>{d.nomeArquivo}</td>
                  <td style={{fontSize:12.5,color:"var(--gray-600)"}}>{d.descricao||"—"}</td>
                  <td style={{fontSize:12}}>{d.tamanho ? `${(d.tamanho/1024).toFixed(1)} KB` : "—"}</td>
                  <td style={{fontSize:12}}>{new Date(d.createdAt).toLocaleString("pt-BR")}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn btn-outline-primary btn-sm btn-icon" title="Baixar" onClick={()=>baixar(d)}><i className="bi bi-download"/></button>
                      <button className="btn btn-outline-danger btn-sm btn-icon" title="Excluir" onClick={()=>excluir(d)}><i className="bi bi-trash3"/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
      }

      {confirmacaoDoc && (
        <ConfirmModal
          titulo={confirmacaoDoc.titulo}
          mensagem={confirmacaoDoc.mensagem}
          textoOk={confirmacaoDoc.textoOk}
          perigo={confirmacaoDoc.perigo}
          onConfirm={confirmacaoDoc.onConfirm}
          onCancel={() => setConfirmacaoDoc(null)}
        />
      )}
    </div>
  );
}

export default function CondominoModal({ show, onClose, onSave, editData, saving=false, condominioNome="", serverError=null }) {
  const isEdit = !!editData?.id;
  const [form, setForm]     = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [tab, setTab]       = useState("dados");
  const [cepLoading, setCepLoading] = useState(false);

  const [cpfStatus,  setCpfStatus]  = useState(null); // null | 'checking' | 'ok' | 'duplicado' | 'invalido'
  const [cpfDupNome, setCpfDupNome] = useState("");
  const cpfDebounceRef = useRef(null);

  const [confirmacao, setConfirmacao] = useState(null);
  const askConfirm = (opts) => new Promise(resolve => setConfirmacao({ ...opts, resolve }));
  const [lgpdErro, setLgpdErro] = useState(null);

  useEffect(() => {
    if (!show) return;
    const base = editData ? { ...EMPTY, ...editData } : { ...EMPTY };
    base.dtCadastro    = sanDate(base.dtCadastro);
    base.dtNascimento  = sanDate(base.dtNascimento);
    base.dtNascConjuge = sanDate(base.dtNascConjuge);
    setForm(base);
    setErrors({});
    setTab("dados");
    setCpfStatus(null);
    setCpfDupNome("");
  }, [show, editData]);

  // Mantém telefone celular sincronizado com nrWhatsApp se nrWhatsApp ainda não existir
  // (para condôminos antigos cadastrados sem WhatsApp)
  useEffect(() => {
    if (form.celular && !form.nrWhatsApp) {
      setForm(p => ({ ...p, nrWhatsApp: p.celular }));
    }
    // eslint-disable-next-line
  }, [form.celular]);

  const set = (field, value) => {
    setForm(p => ({ ...p, [field]: value }));
    setErrors(p => ({ ...p, [field]: undefined }));
  };

  const verificarCPF = async (val, tp) => {
    const tpPes = tp || form.tpPessoa || "Fisica";
    const raw   = val?.replace(/\D/g,"") || "";
    const expectedLen = tpPes === "Fisica" ? 11 : 14;
    if (raw.length < expectedLen) return false;
    setCpfStatus("checking"); setCpfDupNome("");
    try {
      const r = await condominosService.verificarCpf(raw, editData?.id);
      if (r?.disponivel === false) {
        setCpfStatus("duplicado");
        setCpfDupNome(r.nmExistente || "");
        setErrors(p => ({...p, cpf_cnpj: `CPF/CNPJ já cadastrado para "${r.nmExistente}"`}));
        return true;
      }
      setCpfStatus("ok");
      return false;
    } catch { setCpfStatus(null); return false; }
  };

  const fmtDoc = (v) => form.tpPessoa === "Fisica" ? fmtCPF(v) : fmtCNPJ(v);

  const buscarCEP = async (cepRaw) => {
    const cep = (cepRaw||"").replace(/\D/g,"");
    if (cep.length !== 8) return;
    setCepLoading(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await res.json();
      if (!data.erro) {
        setForm(p => ({
          ...p,
          logradouro: data.logradouro || p.logradouro,
          bairro:     data.bairro     || p.bairro,
          cidade:     data.localidade || p.cidade,
          uf:         data.uf         || p.uf,
        }));
      }
    } catch {}
    setCepLoading(false);
  };

  const validate = () => {
    const e = {};
    if (!form.nmCompleto.trim()) e.nmCompleto = "Campo obrigatório";
    if (!form.cpf_cnpj.trim()) {
      e.cpf_cnpj = "Campo obrigatório";
    } else {
      const isOk = form.tpPessoa === "Fisica" ? validarCPF(form.cpf_cnpj) : validarCNPJ(form.cpf_cnpj);
      if (!isOk) e.cpf_cnpj = form.tpPessoa === "Fisica"
        ? "CPF inválido — verifique os dígitos"
        : "CNPJ inválido — verifique os dígitos";
    }
    if (form.email && !emailValido(form.email)) {
      e.email = "E-mail inválido";
    }
    setErrors(e);
    if (e.nmCompleto || e.cpf_cnpj || e.email) { setTab("dados"); return false; }
    return Object.keys(e).length === 0;
  };

  const handleSave = async () => {
    if (form.cpf_cnpj) {
      const isDup = await verificarCPF(form.cpf_cnpj, form.tpPessoa);
      if (isDup) { setTab("dados"); return; }
    }
    if (validate()) onSave({ ...form, id: editData?.id });
  };

  if (!show) return null;

  const isCasado = form.estCivil === "Casado";
  const isPF     = form.tpPessoa === "Fisica";

  const tabs = [
    { id:"dados",     label:"Dados Pessoais",     icon:"bi-person-vcard" },
    { id:"endereco",  label:"Endereço",           icon:"bi-geo-alt" },
    { id:"trabalho",  label:"Trabalho / Cônjuge", icon:"bi-briefcase" },
    { id:"banco",     label:"Banco / PIX",        icon:"bi-bank" },
    { id:"portal",    label:"Acesso ao Portal",   icon:"bi-key", disabled:!isEdit },
    { id:"docs",      label:"Documentos",         icon:"bi-paperclip", disabled:!isEdit },
    { id:"prefs",     label:"Tags / LGPD",        icon:"bi-shield-check" },
  ];

  return (
    <div className="modal fade show d-block" style={{ background:"rgba(0,0,0,.55)" }} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{ width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center" }}>
                <i className="bi bi-person-plus" style={{ fontSize:18,color:"#fff" }}/>
              </div>
              <div>
                <h5 className="modal-title mb-0">{isEdit ? "Editar Condômino" : "Novo Condômino"}</h5>
                <small style={{ color:"rgba(255,255,255,.6)",fontSize:12 }}>
                  {condominioNome || "Cadastro global por cliente — pode vincular a múltiplas unidades depois"}
                </small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>

          {/* Tabs */}
          <div style={{ background:"var(--primary)",padding:"0 24px" }}>
            <ul className="nav nav-tabs border-0" style={{ gap:4 }}>
              {tabs.map(t => (
                <li className="nav-item" key={t.id}>
                  <button className={`nav-link border-0 d-flex align-items-center gap-2 ${tab===t.id?"active":""}`}
                    style={{ background:tab===t.id?"#fff":"transparent", color:tab===t.id?"var(--primary)":"rgba(255,255,255,.7)", borderRadius:"6px 6px 0 0", fontFamily:"Poppins,sans-serif", fontSize:13, fontWeight:500, padding:"10px 18px" }}
                    onClick={() => setTab(t.id)}>
                    <i className={`bi ${t.icon}`}/>{t.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Body */}
          <div className="modal-body">

            {serverError && (
              <div className="alert alert-danger d-flex align-items-center gap-2 py-2 mb-3" style={{ fontSize:13 }}>
                <i className="bi bi-exclamation-triangle-fill"/>
                <div>{serverError}</div>
              </div>
            )}

            {/* ── ABA: DADOS PESSOAIS ── */}
            {tab === "dados" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-person-vcard"/> Identificação</div>
                  <div className="row g-3">
                    {/* Avatar / Foto (1) */}
                    <div className="col-md-2 text-center">
                      <div style={{
                        width:96,height:96,margin:"0 auto",borderRadius:"50%",
                        background:form.avatar?`url(${form.avatar}) center/cover`:"#E2E8F0",
                        display:"flex",alignItems:"center",justifyContent:"center",
                        border:"3px solid #fff",boxShadow:"0 2px 8px rgba(0,0,0,.1)",position:"relative"
                      }}>
                        {!form.avatar && <i className="bi bi-person" style={{fontSize:48,color:"var(--gray-400)"}}/>}
                        {form.avatar && (
                          <button type="button" title="Remover foto" onClick={()=>set("avatar","")}
                            style={{position:"absolute",bottom:-6,right:-6,width:26,height:26,borderRadius:"50%",border:"none",background:"#EF4444",color:"#fff",cursor:"pointer",fontSize:13}}>
                            <i className="bi bi-x"/>
                          </button>
                        )}
                      </div>
                      <label className="btn btn-outline-secondary btn-sm mt-2" style={{fontSize:11}}>
                        <i className="bi bi-camera"/> Foto
                        <input type="file" accept="image/jpeg,image/png,image/webp" hidden
                          onChange={e=>{
                            const f = e.target.files?.[0]; if(!f) return;
                            if(f.size > 1024*1024){
                              setErrors(p => ({ ...p, avatar: "Foto deve ter no máximo 1 MB." }));
                              setTimeout(() => setErrors(p => ({ ...p, avatar: undefined })), 4000);
                              e.target.value=""; return;
                            }
                            setErrors(p => ({ ...p, avatar: undefined }));
                            const r = new FileReader(); r.onload = ev => set("avatar", ev.target.result); r.readAsDataURL(f);
                            e.target.value = "";
                          }}/>
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Nome Completo {isPF ? "" : "/ Razão Social"} <span className="required-mark">*</span></label>
                      <input className={`form-control ${errors.nmCompleto?"is-invalid":""}`} value={form.nmCompleto} onChange={e=>set("nmCompleto",e.target.value)} placeholder={isPF?"Nome completo":"Razão social"}/>
                      {errors.nmCompleto && <div className="invalid-feedback">{errors.nmCompleto}</div>}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Tipo de Pessoa <span className="required-mark">*</span></label>
                      <select className="form-select" value={form.tpPessoa} onChange={e=>{ set("tpPessoa",e.target.value); set("cpf_cnpj",""); setCpfStatus(null); }}>
                        <option value="Fisica">Física</option>
                        <option value="Juridica">Jurídica</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">{isPF?"CPF":"CNPJ"} <span className="required-mark">*</span></label>
                      <div className="input-group">
                        <input className={`form-control ${errors.cpf_cnpj||cpfStatus==="duplicado"?"is-invalid":cpfStatus==="ok"?"is-valid":""}`}
                          value={form.cpf_cnpj}
                          onChange={e=>{
                            const masked = fmtDoc(e.target.value);
                            set("cpf_cnpj", masked);
                            const digits = masked.replace(/\D/g,"");
                            const expectedLen = isPF ? 11 : 14;
                            if (digits.length === expectedLen) {
                              const isOk = isPF ? validarCPF(masked) : validarCNPJ(masked);
                              if (!isOk) {
                                setErrors(p=>({...p, cpf_cnpj: isPF?"CPF inválido — verifique os dígitos":"CNPJ inválido — verifique os dígitos"}));
                                setCpfStatus(null);
                              } else {
                                setErrors(p=>({...p, cpf_cnpj: undefined}));
                                if (cpfDebounceRef.current) clearTimeout(cpfDebounceRef.current);
                                cpfDebounceRef.current = setTimeout(() => verificarCPF(masked, form.tpPessoa), 350);
                              }
                            } else {
                              setErrors(p=>({...p, cpf_cnpj: undefined}));
                              setCpfStatus(null);
                            }
                          }}
                          placeholder={isPF?"000.000.000-00":"00.000.000/0001-00"}/>
                        {cpfStatus==="checking"&&<span className="input-group-text"><span className="spinner-border spinner-border-sm"/></span>}
                        {cpfStatus==="ok"&&<span className="input-group-text text-success"><i className="bi bi-check-circle-fill"/></span>}
                        {cpfStatus==="duplicado"&&<span className="input-group-text text-danger"><i className="bi bi-x-circle-fill"/></span>}
                      </div>
                      {errors.cpf_cnpj && <div className="invalid-feedback d-block">{errors.cpf_cnpj}</div>}
                      {!errors.cpf_cnpj && cpfStatus==="ok" && <div className="text-success mt-1" style={{fontSize:12}}>{isPF?"CPF válido ✓":"CNPJ válido ✓"}</div>}
                      {cpfStatus==="duplicado"&&<div className="text-danger mt-1" style={{fontSize:12}}>
                        <i className="bi bi-exclamation-triangle-fill me-1"/>
                        CPF/CNPJ já cadastrado para <strong>{cpfDupNome}</strong>
                      </div>}
                    </div>

                    {isPF ? <>
                      <div className="col-md-3">
                        <label className="form-label">RG</label>
                        <input className="form-control" value={form.rg} onChange={e=>set("rg",e.target.value)} placeholder="RG"/>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Data de Nascimento</label>
                        <input type="date" className="form-control" value={form.dtNascimento} onChange={e=>set("dtNascimento",e.target.value)}/>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Sexo</label>
                        <select className="form-select" value={form.sexo} onChange={e=>set("sexo",e.target.value)}>
                          <option value="Masculino">Masculino</option>
                          <option value="Feminino">Feminino</option>
                          <option value="Outro">Outro</option>
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Estado Civil</label>
                        <select className="form-select" value={form.estCivil} onChange={e=>set("estCivil",e.target.value)}>
                          {ESTADOS_CIVIS.map(ec=><option key={ec} value={ec}>{LABELS_EC[ec]}</option>)}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Nacionalidade</label>
                        <input className="form-control" value={form.nacionalidade||""} onChange={e=>set("nacionalidade",e.target.value)} placeholder="Brasileira"/>
                      </div>
                    </> : (
                      <div className="col-md-4">
                        <label className="form-label">Inscrição Estadual</label>
                        <input className="form-control" value={form.inscEstadual} onChange={e=>set("inscEstadual",e.target.value)} placeholder="Inscrição estadual"/>
                      </div>
                    )}

                    <div className="col-md-3">
                      <label className="form-label">Data de Cadastro</label>
                      <input type="date" className="form-control" value={form.dtCadastro} onChange={e=>set("dtCadastro",e.target.value)}/>
                    </div>
                    <div className="col-md-2 d-flex align-items-end pb-1">
                      <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="inativo" checked={form.inativo} onChange={e=>set("inativo",e.target.checked)}/>
                        <label className="form-check-label" htmlFor="inativo" style={{ fontSize:13,fontWeight:600,color:"var(--gray-600)" }}>Inativo</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-telephone"/> Contato</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">E-mail
                        <small style={{color:"var(--gray-400)",marginLeft:6,fontSize:11,fontWeight:400}}>(usado para boletos e portal)</small>
                      </label>
                      <input
                        className={`form-control ${errors.email?"is-invalid":""}`}
                        type="email"
                        value={form.email||""}
                        onChange={e=>set("email", e.target.value.toLowerCase().trim())}
                        placeholder="email@exemplo.com"/>
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Telefone</label>
                      <input className="form-control" value={form.telefone||""} onChange={e=>set("telefone",fmtPhone(e.target.value))} placeholder="(00) 0000-0000"/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Celular</label>
                      <input className="form-control" value={form.celular||""} onChange={e=>set("celular",fmtPhone(e.target.value))} placeholder="(00) 00000-0000"/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">WhatsApp
                        <button type="button" className="btn btn-link btn-sm p-0 ms-2" style={{fontSize:11}} onClick={()=>set("nrWhatsApp", form.celular)}>
                          <i className="bi bi-arrow-down-up"/> usar celular
                        </button>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text" style={{background:"#25D366",color:"#fff"}}><i className="bi bi-whatsapp"/></span>
                        <input className="form-control" value={form.nrWhatsApp||""} onChange={e=>set("nrWhatsApp",fmtPhone(e.target.value))} placeholder="(00) 00000-0000"/>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Contato / Referência</label>
                      <input className="form-control" value={form.contato||""} onChange={e=>set("contato",e.target.value)} placeholder="Nome para contato"/>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Observações</label>
                      <textarea className="form-control" rows={2} value={form.observacao||""} onChange={e=>set("observacao",e.target.value)} placeholder="Observações gerais..."/>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* ── ABA: ENDEREÇO ── */}
            {tab === "endereco" && (
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-geo-alt"/> Endereço Pessoal</div>
                <div className="alert alert-light border" style={{fontSize:12}}>
                  <i className="bi bi-info-circle me-2 text-primary"/>
                  Use este endereço quando o condômino <strong>não residir na unidade</strong> (ex: proprietário que aluga). Cobranças e correspondências usarão este endereço.
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">CEP</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        value={form.cep||""}
                        onChange={e=>set("cep", fmtCEP(e.target.value))}
                        onBlur={e=>buscarCEP(e.target.value)}
                        placeholder="00000-000"
                        maxLength={9}/>
                      <button className="btn btn-outline-secondary" type="button" onClick={()=>buscarCEP(form.cep)} disabled={cepLoading} title="Buscar CEP">
                        {cepLoading ? <span className="spinner-border spinner-border-sm"/> : <i className="bi bi-search"/>}
                      </button>
                    </div>
                    <small style={{ color:"var(--gray-400)", fontSize:11 }}>Preenche o endereço automaticamente</small>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Logradouro</label>
                    <input className="form-control" value={form.logradouro||""} onChange={e=>set("logradouro",e.target.value)} placeholder="Rua, Avenida..."/>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Número</label>
                    <input className="form-control" value={form.numero||""} onChange={e=>set("numero",e.target.value)} placeholder="Nº"/>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Complemento</label>
                    <input className="form-control" value={form.complemento||""} onChange={e=>set("complemento",e.target.value)} placeholder="Apto, Bloco..."/>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Bairro</label>
                    <input className="form-control" value={form.bairro||""} onChange={e=>set("bairro",e.target.value)} placeholder="Bairro"/>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Cidade</label>
                    <input className="form-control" value={form.cidade||""} onChange={e=>set("cidade",e.target.value)} placeholder="Cidade"/>
                  </div>
                  <div className="col-md-1">
                    <label className="form-label">UF</label>
                    <select className="form-select" value={form.uf||"SP"} onChange={e=>set("uf",e.target.value)}>
                      {estadosBR.map(uf => <option key={uf}>{uf}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            )}

            {/* ── ABA: TRABALHO / CÔNJUGE ── */}
            {tab === "trabalho" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-briefcase"/> Dados Profissionais</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Profissão</label>
                      <input className="form-control" value={form.profissao||""} onChange={e=>set("profissao",e.target.value)} placeholder="Profissão"/>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label">Local de Trabalho</label>
                      <input className="form-control" value={form.localTrabalho||""} onChange={e=>set("localTrabalho",e.target.value)} placeholder="Empresa / Local"/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Tel. Comercial</label>
                      <input className="form-control" value={form.telComercial||""} onChange={e=>set("telComercial",fmtPhone(e.target.value))} placeholder="(00) 0000-0000"/>
                    </div>
                  </div>
                </div>

                {isCasado ? (
                  <div className="form-section">
                    <div className="form-section-title"><i className="bi bi-people"/> Dados do Cônjuge</div>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label">Nome do Cônjuge</label>
                        <input className="form-control" value={form.nmConjuge||""} onChange={e=>set("nmConjuge",e.target.value)} placeholder="Nome completo"/>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Profissão do Cônjuge</label>
                        <input className="form-control" value={form.profConjuge||""} onChange={e=>set("profConjuge",e.target.value)} placeholder="Profissão"/>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">CPF do Cônjuge</label>
                        <input className="form-control" value={form.cpfConjuge||""} onChange={e=>set("cpfConjuge",fmtCPF(e.target.value))} placeholder="000.000.000-00"/>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">RG do Cônjuge</label>
                        <input className="form-control" value={form.rgConjuge||""} onChange={e=>set("rgConjuge",e.target.value)} placeholder="RG"/>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Data de Nascimento</label>
                        <input type="date" className="form-control" value={form.dtNascConjuge||""} onChange={e=>set("dtNascConjuge",e.target.value)}/>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign:"center",padding:"40px 0",color:"var(--gray-400)" }}>
                    <i className="bi bi-people" style={{ fontSize:36,display:"block",marginBottom:8 }}/>
                    <p style={{ fontSize:14 }}>Dados do cônjuge disponíveis apenas para estado civil <strong>Casado(a)</strong></p>
                    <p style={{ fontSize:12 }}>Altere o estado civil na aba "Dados Pessoais".</p>
                  </div>
                )}
              </>
            )}

            {/* ── ABA: BANCO / PIX ── */}
            {tab === "banco" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-qr-code"/> Chave PIX</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Tipo de chave</label>
                      <select className="form-select" value={form.pixTipo||""} onChange={e=>set("pixTipo",e.target.value)}>
                        <option value="">— Selecione —</option>
                        <option value="CPF">CPF</option>
                        <option value="CNPJ">CNPJ</option>
                        <option value="Email">E-mail</option>
                        <option value="Telefone">Telefone</option>
                        <option value="Aleatoria">Aleatória</option>
                      </select>
                    </div>
                    <div className="col-md-9">
                      <label className="form-label">Chave PIX</label>
                      <input className="form-control" value={form.pixChave||""} onChange={e=>set("pixChave",e.target.value)} placeholder={form.pixTipo==="Email"?"email@exemplo.com":form.pixTipo==="Telefone"?"+55 (11) 90000-0000":"chave PIX"}/>
                      <small className="text-muted" style={{fontSize:11}}>Útil para repasses (aluguel, restituição) e identificação em devoluções.</small>
                    </div>
                  </div>
                </div>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-bank"/> Conta Bancária</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Banco</label>
                      <input className="form-control" value={form.bancoNome||""} onChange={e=>set("bancoNome",e.target.value)} placeholder="Ex: Banco do Brasil"/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Agência</label>
                      <input className="form-control" value={form.bancoAgencia||""} onChange={e=>set("bancoAgencia",e.target.value)} placeholder="0000"/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Conta</label>
                      <input className="form-control" value={form.bancoConta||""} onChange={e=>set("bancoConta",e.target.value)} placeholder="00000-0"/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Tipo</label>
                      <select className="form-select" value={form.bancoTpConta||"Corrente"} onChange={e=>set("bancoTpConta",e.target.value)}>
                        <option value="Corrente">Corrente</option>
                        <option value="Poupanca">Poupança</option>
                      </select>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* ── ABA: ACESSO AO PORTAL ── */}
            {tab === "portal" && (
              <PortalAcessoCondomino
                idCondomino={editData?.id}
                emailCondomino={form.email}
                inativo={!!form.inativo}
              />
            )}

            {/* ── ABA: DOCUMENTOS ── */}
            {tab === "docs" && (
              <DocumentosCondomino idCondomino={editData?.id} onError={msg=>{}}/>
            )}

            {/* ── ABA: TAGS / PREFERÊNCIAS / LGPD ── */}
            {tab === "prefs" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-tags"/> Tags / Categorização</div>
                  <input className="form-control" value={form.tags||""} onChange={e=>set("tags",e.target.value)} placeholder="vip, idoso, comissao-financeira (separadas por vírgula)"/>
                  <div className="d-flex flex-wrap gap-1 mt-2">
                    {(form.tags||"").split(",").map(t=>t.trim()).filter(Boolean).map((t,i)=>(
                      <span key={i} className="badge text-bg-light border" style={{fontSize:11}}>{t}</span>
                    ))}
                  </div>
                  <small className="text-muted" style={{fontSize:11}}>Use tags para segmentar comunicados, filtros e relatórios.</small>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-cake2"/> Aniversário</div>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" id="anivOpt" checked={!!form.aniversarioOptIn} onChange={e=>set("aniversarioOptIn", e.target.checked?1:0)}/>
                    <label className="form-check-label" htmlFor="anivOpt">Receber felicitações automáticas no aniversário</label>
                  </div>
                  {form.dtNascimento ? (
                    <small className="text-muted" style={{fontSize:11,display:"block",marginTop:6}}>
                      Data de nascimento atual: <strong>{new Date(form.dtNascimento+"T12:00:00").toLocaleDateString("pt-BR")}</strong>
                    </small>
                  ) : <small className="text-warning" style={{fontSize:11}}>Sem data de nascimento — preencha em "Dados Pessoais" para receber as felicitações.</small>}
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-shield-check"/> LGPD</div>
                  {form.lgpdAceite ? (
                    <div className="alert alert-success py-2" style={{fontSize:13}}>
                      <i className="bi bi-check-circle-fill me-2"/>
                      Termo aceito {form.lgpdAceiteEm ? `em ${new Date(form.lgpdAceiteEm).toLocaleString("pt-BR")}` : ""} — versão {form.lgpdVersao||"1.0"}
                      <button type="button" className="btn btn-link btn-sm ms-2 text-danger" style={{fontSize:11}}
                        onClick={async ()=>{
                          if(!editData?.id) return;
                          const ok = await askConfirm({ titulo:"Revogar aceite LGPD?", mensagem:"Esta ação removerá o aceite do termo LGPD para este condômino.", textoOk:"Revogar", perigo:true });
                          if(!ok) return;
                          try{ await condominosService.lgpdRevogar(editData.id); set("lgpdAceite",0); set("lgpdAceiteEm",""); setLgpdErro(null); }
                          catch(e){ setLgpdErro(e?.message || "Erro ao revogar."); }
                        }}>
                        revogar
                      </button>
                    </div>
                  ) : (
                    <div className="alert alert-warning py-2" style={{fontSize:13}}>
                      <i className="bi bi-exclamation-triangle-fill me-2"/>
                      Termo LGPD ainda não aceito por este condômino.
                      {editData?.id && <button type="button" className="btn btn-sm btn-outline-success ms-2" style={{fontSize:11}}
                        onClick={async ()=>{
                          try{ await condominosService.lgpdAceitar(editData.id, "1.0"); set("lgpdAceite",1); set("lgpdAceiteEm",new Date().toISOString()); set("lgpdVersao","1.0"); setLgpdErro(null); }
                          catch(e){ setLgpdErro(e?.message || "Erro ao registrar aceite."); }
                        }}>
                        Registrar aceite agora
                      </button>}
                    </div>
                  )}
                  {lgpdErro && (
                    <div className="alert alert-danger py-1 my-2" style={{fontSize:12}}>
                      <i className="bi bi-exclamation-triangle-fill me-2"/>{lgpdErro}
                    </div>
                  )}
                  <small className="text-muted" style={{fontSize:11}}>O condômino também aceita pelo portal no primeiro acesso (versão atual: 1.0).</small>
                </div>
              </>
            )}
          </div>

          {/* Footer */}
          <div className="modal-footer d-flex justify-content-between">
            <div style={{ fontSize:12,color:"var(--gray-400)" }}>
              <i className="bi bi-asterisk me-1" style={{ color:"#ef4444",fontSize:9 }}/>Campos obrigatórios
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving || cpfStatus==="checking" || cpfStatus==="duplicado"}>
                {saving ? <><span className="spinner-border spinner-border-sm me-2"/>Salvando...</> : <><i className="bi bi-check-circle"/> {isEdit?"Salvar Alterações":"Cadastrar"}</>}
              </button>
            </div>
          </div>
        </div>
      </div>

      {confirmacao && (
        <ConfirmModal
          titulo={confirmacao.titulo}
          mensagem={confirmacao.mensagem}
          textoOk={confirmacao.textoOk}
          perigo={confirmacao.perigo}
          onConfirm={() => { confirmacao.resolve(true); setConfirmacao(null); }}
          onCancel={() => { confirmacao.resolve(false); setConfirmacao(null); }}
        />
      )}
    </div>
  );
}
